import axios from 'axios';
import apiConfig from '../apiConfig';
import { getAxiosInstance } from '../../utils/axiosApi';

const axiosInstance = getAxiosInstance({
  baseUrl: `${apiConfig.IAMUrl}`,
});

const getRoleByRoleId = async ({ roleID }, abortController) => {
  try {
    const response = await axiosInstance.get(`api/v1/Role/id/${roleID}`, {
      signal: abortController?.signal
    });
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};

const getScreenAccessAutoComplete = async ({ id }) => {
  console.log('getScreenAccessAutoComplete id: ', id);
  try {
    // const response = await axiosInstance.get(`api/v1/Role/id/${id}`, {
    const response = await axiosInstance.get(`api/v1/User/id/${id}/petrohub`, {
      // signal: abortController?.signal
    });
    return response.data;
  } catch (e) {
    throw new Error('Error fetch screen access');
  }
};

const getRoleFunctionality = async (abortController) => {
  try {
    const response = await axiosInstance.get('api/v1/Role/Functionality/All', {
      signal: abortController?.signal
    });
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};

const getRoleCustomFunctionality = async (abortController) => {
  try {
    const response = await axiosInstance.get('api/v1/Role/CustomFunction/All', {
      signal: abortController?.signal
    });
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};

// Role Management API (~ USER API)
const searchRoles = async ({ roleName, active, page, pageSize, sortBy }) => {
  const queryParams = [];

  if (roleName && roleName.trim() !== '') {
    queryParams.push(`roleName=${encodeURIComponent(roleName.trim())}`);
    queryParams.push('roleNameOp=Contains');
  }

  if (active != null) {
    queryParams.push(`active=${active}`);
  }

  if (page) {
    queryParams.push(`currentPage=${page}`);
  }

  if (pageSize) {
    queryParams.push(`pageSize=${pageSize}`);
  }

  if (sortBy) {
    queryParams.push(`sortBy=${sortBy}`);
  }

  try {
    const response = await axiosInstance.get(
      `Role/Search/by?${queryParams.join('&')}`
    );

    return response.data;
  } catch (error) {
    if (!axios.isCancel(error)) {
      throw error;
    }
  }

  return {};
};

const createRole = async ({
  roleName,
  description,
  active,
  createdOn,
  createdBy,
}) => {
  try {
    const response = await axiosInstance.post('api/v1/Role/insert', {
      RoleName: roleName,
      Description: description,
      Active: active,
      CreatedOn: createdOn,
      CreatedBy: createdBy,
      LastUpdatedBy: createdBy,
      LastUpdatedOn: createdOn,
    });

    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};

const updateRole = async ({
  RoleID,
  RoleName,
  Description,
  CreatedOn,
  CreatedBy,
  LastUpdatedOn,
  LastUpdatedBy,
  Active,
  Functionalities,
  CustomFunctions,
}) => {
  try {
    // const response = await axiosInstance.post('api/v1/Role/update/', {
    const response = await axiosInstance.post('api/v1/User/Update/Role/Petrohub', {
      RoleID,
      RoleName,
      Description,
      CreatedOn,
      CreatedBy,
      LastUpdatedBy,
      LastUpdatedOn,
      Active,
      Functionalities,
      CustomFunctions,
    });

    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};

const RoleApi = {
  searchRoles,
  getRoleByRoleId,
  getRoleCustomFunctionality,
  getRoleFunctionality,
  getScreenAccessAutoComplete,
  updateRole,
  createRole,
};

export default RoleApi;
